import { type JSX } from "react";
import { type ModalProps } from "../Modal";
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter } from "@heroui/react";
import { Button } from "@heroui/react";
export interface PrintInfoModalProps extends Partial<ModalProps> {
    onClose: () => void;
    onConfirmation: () => void;
    isOpen: boolean;
}

export const PrintInfoModal = (
    props: PrintInfoModalProps
): JSX.Element => {
    return (
        <Modal
            isOpen={props.isOpen}
            onClose={props.onClose}
            isDismissable={false}
            isKeyboardDismissDisabled={true}
            hideCloseButton={true}
            size="md"
            classNames={{
                base: "border-0",
                backdrop: "bg-gradient-to-t from-zinc-900 to-zinc-900/10 backdrop-opacity-20",
            }}
        >
            <ModalContent className="py-6">
                {() => (
                    <>
                        <ModalHeader className="flex flex-col gap-1 items-center pt-6">
                            <div className="w-16 h-16 rounded-full bg-yellow-100 dark:bg-yellow-900/20 flex items-center justify-center mb-2">
                                <svg
                                    className="w-8 h-8 text-yellow-600 dark:text-yellow-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                    />
                                </svg>
                            </div>
                        </ModalHeader>
                        <ModalBody className="text-center px-6 pb-4">
                            <div className="text-gray-600 dark:text-gray-300 text-base text-center leading-relaxed">
                                When printing or exporting to PDF, set <b>margins to None</b> and use <b>A4 page size</b> in your print settings to ensure proper layout.
                            </div>
                        </ModalBody>
                        <ModalFooter className="flex justify-center pb-6">
                            <Button
                                onPress={props.onConfirmation}
                                className="bg-[var(--okay-button)] hover:bg-blue-800 text-white font-semibold px-8 py-2.5 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl min-w-[120px]"
                                size="lg"
                            >
                                Got it
                            </Button>
                             <Button
                                onPress={props.onClose}
                                className="font-semibold px-8 py-2.5 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl min-w-[120px]"
                                size="lg"
                            >
                                Cancel
                            </Button>
                        </ModalFooter>
                    </>
                )}
            </ModalContent>
        </Modal>

    );
};

